import map from 'lodash/map'
import React, { FC } from 'react'

import { SpecificationsItem } from '@Components/Product/Specifications/Item'
import { ProductSpecificationItemWithMultiple } from '@Generated/graphql'

import styles from './Group.module.scss'

interface SpecificationsGroupProps {
  items: ProductSpecificationItemWithMultiple[]
}

export const SpecificationsGroup: FC<SpecificationsGroupProps> = ({ items }) => (
  <div className={styles.group}>
    {map(items, (data, index) => <SpecificationsItem key={`${data.name}_${index}`} specification={data} />)}
  </div>
)
